import { Link } from 'react-router-dom';

const footerGroups = [
  {
    title: '内容栏目',
    links: [
      { to: '/community', label: '讨论社区' },
      { to: '/topics', label: '专题文章' },
      { to: '/faq', label: '常见问题' },
    ],
  },
  {
    title: '关于社区',
    links: [
      { to: '/about', label: '关于我们' },
      { to: '/contact', label: '联系我们' },
      { to: '/community', label: '加入讨论' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-foreground-100">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className="ri-sparkling-fill text-lg"></i>
              </span>
              <span className="font-heading text-2xl text-background-50">羞羞动漫社</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-300">
              一个属于动漫漫画同好的讨论交流社区。在这里分享追番心得、讨论剧情走向、安利心头好，寻找愿意陪你一起追更到天亮的人。
            </p>
            <div className="mt-5 flex items-center gap-3">
              {['ri-bilibili-line', 'ri-wechat-line', 'ri-weibo-line', 'ri-mail-line'].map((ic) => (
                <a
                  key={ic}
                  href="#"
                  rel="nofollow"
                  aria-label="社区社交链接"
                  className="flex h-9 w-9 items-center justify-center rounded-lg bg-foreground-800 text-foreground-300 hover:bg-primary-500 hover:text-background-50 transition-colors"
                >
                  <i className={`${ic} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          {footerGroups.map((g) => (
            <div key={g.title}>
              <h4 className="text-sm font-semibold text-background-50">{g.title}</h4>
              <ul className="mt-4 space-y-3">
                {g.links.map((l) => (
                  <li key={l.label}>
                    <Link
                      to={l.to}
                      className="text-sm text-foreground-300 hover:text-primary-300 transition-colors"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-3 border-t border-foreground-800 pt-6">
          <p className="text-xs text-foreground-400">
            © {new Date().getFullYear()} 羞羞动漫社 · 动漫同好讨论交流社区
          </p>
          <p className="text-xs text-foreground-400">以热爱为伴，与同好同行</p>
        </div>
      </div>
    </footer>
  );
}